<template>
  <v-card color="grey lighten-3" class="pa-2 mb-3">
    <v-card-title>
      <h4 class="subheading my-0">Datos del período de prueba</h4>
    </v-card-title>
    <v-layout wrap>
      <v-flex xs6 pr-3>
        <v-select
          v-model="formData.periodo_de_prueba"
          :disabled="disabled"
          @input="$emit('input', formData)"
          :label="$t('Tipo de período de prueba')"
          :items="tiposDePeriodoDePrueba"
          :rules="[]"
          required
          item-text="label"
          item-value="value"
          box
          :menu-props="{
            bottom: true,
            'offset-y': true,
          }"
        ></v-select>
      </v-flex>

      <template v-if="formData.periodo_de_prueba === 'pactada'">
        <v-flex xs6 pr-3>
          <v-text-field
            v-model="formData.plazo_periodo_de_prueba"
            :disabled="disabled"
            :label="$t('Plazo del período de prueba')"
            :rules="[]"
            box
          ></v-text-field>
        </v-flex>
      </template>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          periodo_de_prueba: null,
          plazo_periodo_de_prueba: null,
        };
      },
    },
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      tiposDePeriodoDePrueba: [
        { label: 'Según convenio', value: 'convenio' },
        { label: 'Pactada', value: 'pactada' },
      ],
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {
    formData: {
      handler: function(val, oldVal) {
        if (val.periodo_de_prueba === 'convenio') {
          this.formData.plazo_periodo_de_prueba = null;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss"></style>
